import { contentLoaded } from '../globals';
import { initMasonryColumns } from '../masonry';

export async function landingPage(element: HTMLElement) {
	await contentLoaded;
	initMasonryColumns(element.querySelector('.is-masonry'));
}
